import React from 'react'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import chroma from 'chroma-js';
import "./style.css"

const animatedComponents = makeAnimated();

const ReactSelect = props => {
    const styles = {
        control: (styles) => ({ ...styles, menuPortal: base => ({ ...base, zIndex: 9999 }), backgroundColor: chroma(props.err ? "pink" : "white").alpha(0.3).css(), borderColor: chroma(props.err ? "red" : "B3B3B3").alpha(0.5).css() }),
        menuList: (styles) => ({ ...styles, menuPortal: base => ({ ...base, zIndex: 9999 }), })
    };
    const formatGroupLabel = data => {
        return props.groupdOptions ? <div style={groupStyles}>
            <span>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div> : null
    }
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };
    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    };
    return (
        <Select
            isMulti
            menuPortalTarget={document.body}
            blurInputOnSelect={false}
            styles={styles}
            isDisabled={props.disabled}
            placeholder={props.placeholder}
            closeMenuOnSelect={false}
            closeMenuOnScroll={true}
            components={animatedComponents}
            defaultValue={props.defaults}
            options={props.groupdOptions ? props.groupdOptions : props.options}
            formatGroupLabel={formatGroupLabel}
            onChange={props.handleChange}
        />
    );
}

export default ReactSelect